<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search" :default-data="defaultSearchData">
                        <m-search-item label="姓名">
                            <c-input name="user_name"></c-input>
                        </m-search-item>
                        <m-search-item label="身份">
                            <c-select name="identity_type" :options="identityOptions"></c-select>
                        </m-search-item>
                        <m-search-item label="采购供应商">
                            <c-select name="supplier_id" async @search="searchSupplier"></c-select>
                        </m-search-item>
                        <m-search-item label="统计日期"  colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <!--身份-->
                <template #identity_type="{data}">
                    <c-state tag async dict="USER_IDENTITY" :value="data.identity_type"></c-state>
                </template>
                <!--期初应付-->
                <template #begin_amount="{data}">
                    <span>￥{{ formatMoney(data.begin_amount) }}</span>
                </template>
                <!--本期新增-->
                <template #period_amount="{data}">
                    <span>￥{{ formatMoney(data.period_amount) }}</span>
                </template>
                <!--本期结算-->
                <template #settle_amount="{data}">
                    <span>￥{{ formatMoney(data.settle_amount) }}</span>
                </template>
                <!--本期结算中金额-->
                <template #settling_amount="{data}">
                    <span>￥{{ formatMoney(data.settling_amount) }}</span>
                </template>
                <!--期末结余-->
                <template #end_amount="{data}">
                    <span>￥{{ formatMoney(data.end_amount) }}</span>
                </template>
                <!--预付账款-->
                <template #advance_amount="{data}">
                    <span>￥{{ formatMoney(data.advance_amount) }}</span>
                </template>
            </view-list>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'm_receivable_summary',

    data() {
        //变更时间格式化（yyyy-MM-dd）
        const pad = num => (num < 10 ? '0' + num : '' + num);
        const formatDate = date => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
        const now = new Date();
        const defaultStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30);   //默认开始时间：30天前

        return {
            workType: 133,
            //变更时间默认值（必填：默认30天前 ~ 今日，可修改不可清空）
            defaultSearchData: {
                start_date: `${formatDate(defaultStartDate)} 00:00:00`,
                end_date: `${formatDate(now)} 23:59:59`
            },
        }
    },

    computed: {
        ...mapState(['saasInfo']),

        /** 身份选项：1=员工 2=供应商联系人 3=小黑回收会员 */
        identityOptions() {
            return [
                {name: '员工', value: 1},
                {name: '供应商联系人', value: 2},
                {name: '小黑回收会员', value: 3}
            ]
        }
    },

    methods: {
        /*******搜索【采购供应商】下拉框信息*****************/
        searchSupplier(keyword, resolve) {
            this.request({
                url: '/system/options',
                data: {
                    options_code: 'SUPPLIER',
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },

        /**
         * 金额格式化（保留两位小数）
         */
        formatMoney(value) {
            if (value === undefined || value === null || value === '') {
                return '0.00';
            }
            var num = Number(value);
            if (isNaN(num)) {
                return '0.00';
            }
            return num.toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        }
    }
}
</script>
